<div class="info">
  <div class="info-header">
    <div class="container-label">{{ title$ | async }}</div>
    <ng-container *ngIf="employmentHistory$ | async as employment">
      <app-current-employer-pill *ngIf="employment | isCurrentEmployment" />
    </ng-container>
  </div>
</div>
<div class="info-container">
  <div class="data-container" [ngClass]="{ 'w-100': item?.fullWidth }" *ngFor="let item of items$ | async">
    <span class="info-label">{{ item?.infoLabel }}</span>
    <div class="d-flex justify-content-between">
      <ng-container *ngTemplateOutlet="nameLabelTemplate; context: { item: item }" />
    </div>
  </div>
</div>

<ng-template #nameLabelTemplate let-item="item">
  <div class="name-label justify-content-start gap-3">
    <div>
      {{ item?.value ?? '-' }}
    </div>
  </div>
</ng-template>
